import goals from "../utils/goals";
import UIComponent from "../ui/component";
import FilesApi from "../api/files";
import api from "../api";

export class UploadCheckout extends UIComponent {
    init() {
        this.includeComponents({
            errorBag: "document@.js-upload-form-error",
            uploadModal: "document@#upload-modal",
        });

        if (!Number(this.available_region)) {
            this.includeComponents({
                regionPaymentModal:
                    'document@#regionPaymentModal',
            });
        }

        this.transcodeBtn?.on("click", this.onTranscodeBtnClick.bind(this));
        this.transcribeUrl = this.attr("data-url");

        this.operationSubscription?.on(
            "payClick",
            this.onOfferSelected.bind(this)
        );
        this.offerSubscription?.on("payClick", this.onOfferSelected.bind(this));
    }

    preloaderShow() {
        this.preloader.show();
        this.totalPanel.hide();
    }

    preloaderHide() {
        this.preloader.hide();
        this.totalPanel.show();
    }

    onTranscodeBtnClick(e) {
        e.preventDefault();
        goals.reach("transcode");
        this.transcodeBtn.disable();

        const files = this.parent.dropzone.files;

        const goodFiles = files.filter(
            (f) => !f.error && f.status !== "download_error"
        );

        const badFiles = files.filter(
            (f) => f.error || f.status === "download_error"
        );

        for (const file of badFiles) {
            if (file.transcription_id) {
                this.parent.deleteFile(file.transcription_id);
            }
        }

        const payload = {
            files: goodFiles.map((f) => f.transcription_id),
            options: this.parent.getFiles().options,
        };

        console.log(payload);

        FilesApi.transcribe(payload)
            .then((response) => {
                this.transcodeBtn.disable();
            })
            .catch((errors) => {
                this.transcodeBtn.enable();
                this.errorBag.show(errors);
            });
    }

    update(files) {
        this.preloaderShow();
        FilesApi.calculate(files)
            .then(this.onUpdateResponse.bind(this))
            .catch((errors) => {
                this.preloaderHide();
                this.offerSubscription.hide();
                this.operationSubscription.hide();
                this.transcodeBtn.hide();
                this.errorBag.show(errors);
            });
    }

    onOfferSelected(e) {
        goals.reach(`${e.detail?.offer}_selected`);

        const formData = this.parent.getFiles();
        formData.addToQueue = 1;
        formData.offer = e.detail?.offer;

        formData.return =
            window.location.href +
            (this.uploadModal?.isShown() && !window.location.href.includes("#")
                ? "#upload-modal"
                : "");

        if (!Number(this.available_region)) {
            if (this.uploadModal?.isShown()) {
                this.uploadModal?.hide();
            }

            this.regionPaymentModal?.show(formData, true);
            return;
        }

        FilesApi.transcribe(formData)
            .then((response) => {
                this.handleOfferResponse(response);
            })
            .catch((error) => {
                button.disabled = false;
                this.errorBag.show(
                    error.message || "Payment processing failed"
                );
            });
    }

    handleOfferResponse(response) {
        // console.log("handleOfferResponse", response);
    }

    onUpdateResponse(response) {
        goals.reach("calculate");
        this.totalPanel.total_duration = response.totalDuration;
        this.totalPanel.available = response.available;
        this.totalPanel.offers = response.offers || {};

        const offers = response.offers || {};
        const hasOffers = Object.keys(offers).length > 0;

        if (response.notEnoughDuration !== "0:00:00") {
            this.totalPanel.parent.not_enough_duration.show();
            this.totalPanel.parent.not_enough_duration.value =
                response.notEnoughDuration;
        } else {
            this.totalPanel.parent.not_enough_duration.hide();
            this.totalPanel.parent.not_enough_duration.value = '';
        }

        if (hasOffers) {
            this.offers.show();

            for (let i in offers) {
                const offer = offers[i];

                if (offer.type === "payperminute") {
                    this.operationSubscription?.update(offer);
                    this.operationSubscription?.show();
                    if (offer.is_minimal_amount === true) {
                        this.operationSubscription.mini_price?.show();
                        this.operationSubscription.mini_info?.show();
                    } else {
                        this.operationSubscription.mini_price?.hide();
                        this.operationSubscription.mini_info?.hide();
                    }
                } else if (offer.type === "subscription") {
                    this.offerSubscription?.update(offer);
                    this.offerSubscription?.show();
                }

                if (offer.type !== "subscription") {
                    this.offerSubscription?.hide();
                }
            }

            this.transcodeBtn?.hide();
        } else {
            this.offers.hide();

            this.operationSubscription?.hide();
            this.offerSubscription?.hide();

            this.transcodeBtn?.show();
            this.transcodeBtn?.enable();

            this.payBtn?.hide();
        }

        this.preloaderHide();
    }
}
